import { oneOf } from 'prop-types';

export const INTEGRATE_ENV_TYPE = {
  MCA: 'MCA',
  UP: 'UP',
  STANDALONE: 'StandAlone',
  UP_WIZARD: 'UpWizard',
  SUB_ADS_WIZARD: 'SubAdsWizard',
  SUB_ADS_WIZARD2: 'SubAdsWizard2',
  STREAMLINED_WIZARD: 'StreamlinedWizard',
  PMAX_LITE_WIZARD: 'PmaxLiteWizard',
  NOT_STANDALONE: 'NotStandalone',
};

export const envPropTypes = oneOf([
  INTEGRATE_ENV_TYPE.MCA,
  INTEGRATE_ENV_TYPE.UP,
  INTEGRATE_ENV_TYPE.STANDALONE,
  INTEGRATE_ENV_TYPE.UP_WIZARD,
  INTEGRATE_ENV_TYPE.SUB_ADS_WIZARD,
  INTEGRATE_ENV_TYPE.SUB_ADS_WIZARD2,
  INTEGRATE_ENV_TYPE.STREAMLINED_WIZARD,
  INTEGRATE_ENV_TYPE.PMAX_LITE_WIZARD,
  INTEGRATE_ENV_TYPE.NOT_STANDALONE,
]);
